import { DoodProductModel, IProductLabelWithMeta } from '@core/models/product.model';
import { ProductKeys } from '@config/keys/product.keys';

const DISCOUNT_PROMOTION_TYPES = [
  'fixed-price-for-products',
  'percentage-discount-on-products',
] as const;

/**
 * Returns true if the product has at least one promotion label of type
 * 'fixed-price-for-products' or 'percentage-discount-on-products'.
 */
export function hasDiscountPromotionLabel(product: DoodProductModel): boolean {
  const labels = product[ProductKeys.Labels] as IProductLabelWithMeta[] | undefined;
  if (!labels?.length) {
    return false;
  }
  const result = labels.some(
    label =>
      label._meta?.type &&
      (DISCOUNT_PROMOTION_TYPES as readonly string[]).includes(label._meta.type),
  );
  return result;
}
